<template>
  <div class="group_experiment_board ma-0">
    <v-row v-if="current.user_level=='ADMIN'">
      <v-col>
        <v-select v-if="$i18n.locale=='tc'"
          :items="api.schools"
          item-text="id_chi_name"
          item-value="school_id"
          v-model="form.school_id"
          label="School"
          :disabled="current.user_level!='ADMIN'"
          @change="goTo(form.school_id)"
        ></v-select>
        <v-select v-else
          :items="api.schools"
          item-text="id_name"
          item-value="school_id"
          v-model="form.school_id"
          label="School"
          :disabled="current.user_level!='ADMIN'"
          @change="goTo(form.school_id)"
        ></v-select>
      </v-col>
    </v-row>
    <div class='mt-5 mb-2 title d-flex'>
      <span><v-img width="30px" :src='api.school_logo_url' /></span>
      <span v-if="$i18n.locale=='tc'" class='ml-2'> {{ api.school_chi_name }} </span>
      <span v-else class='ml-2'> {{ api.school_name }} </span>
      <span class="ml-auto">
        <v-btn color="light-green lighten-3" @click="dialog_calendar = true; componentKey+=1">
          <v-icon>mdi-calendar</v-icon>
          {{ $t("booking.calendar_btn") }}
        </v-btn>
      </span>
    </div>
    <v-row class="mx-3">
      <v-spacer></v-spacer>
      
    </v-row>
    <v-expansion-panels class="my-3" v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header color="green lighten-5">
          <h5>Ongoing Group Experiment</h5>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col
              v-for="(item, index) in api.group_experiment_slots" :key="index" cols="12" sm="6" md="4">
              <v-card class="mx-auto" max-width="350px">
                 <v-img 
                  height="320px"
                  class="d-flex align-end"
                  cover
                  :src="item.latest_img_path"
                  :alt="item.experiment_set"
                >
                  <div class="d-flex align-end" style="background: rgba(0,0,0,0.4);">
                    <v-card-text class="white--text p-2">
                      <div v-if="item.latest_img_datetime!=''">Photo taken: {{ item.latest_img_datetime }}</div>
                    </v-card-text>
                  </div>
                </v-img>
                <v-card-title>
                  {{ item.experiment_set }}
                </v-card-title>

                <div class="text-body-2 pl-6 mt-n4">
                  <table>
                    <tr>
                      <td>Start: </td>
                      <td class="pl-2">{{ item.start_datetime }}</td>
                    </tr>
                    <tr>
                      <td>End: </td>
                      <td class="pl-2">{{ item.end_datetime }}</td>
                    </tr>
                  </table>
                </div>

                <v-card-actions>
                  <v-btn v-if="!item.show" rounded text @click="item.show = !item.show">See More<v-icon>mdi-chevron-down</v-icon></v-btn>
                  <v-btn v-else rounded text @click="item.show = !item.show">Show Less<v-icon>mdi-chevron-up</v-icon></v-btn>
                  <v-spacer></v-spacer>
                  <div>
                    <v-icon v-if="(item.eStatus=='HOLD')" color="red" >mdi-alert-circle</v-icon>
                    <v-btn
                      color="primary"
                      :disabled="item.eStatus=='HOLD'"
                      @click="enterGroupLab(item)"
                    >
                      {{ $t("booking.btn.enter_lab") }}
                    </v-btn>
                  </div>
                </v-card-actions>
                <v-row class="text-right">
                  <v-col class="pt-0">
                    <div v-if="item.eStatus=='HOLD' && (current.user_level == 'INCHARGE' || current.user_level=='ADMIN')">
                      <v-btn
                        color="error"
                        text
                        :disabled="item.eStatus=='ACTIVE'"
                        @click="enterGroupLab(item)"
                      >
                        Force Enter
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-expand-transition>
                  <div v-if="item.config!=null" v-show="item.show">
                    <v-divider class="mt-2 mx-5"></v-divider>
                    <v-card-text class="pt-0 text-body-1 font-weight-bold">
                      Experiment Setting:
                      <div class="text-body-2 px-auto">
                        <table>
                          <tr v-for="(value, key) in item.config" :key="key">
                            <td>{{ key }}:</td>
                            <td class="pl-2">{{ value }}</td>
                          </tr>
                        </table>
                      </div>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="dialog_calendar" fullscreen hide-overlay>
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_calendar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("booking.calendar.dialog_title") }}</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <Calendar :key="componentKey" :schoolName="api.school_name" :schoolChiName="api.school_chi_name"  :schoolLogoUrl="api.school_logo_url" />
      </v-card>
    </v-dialog>
    <router-view @info="schoolInfo" :key="childrenKey" :par="par" ref="mab"></router-view>
  </div>
</template>
<script>
import moment from "moment";

import {api_booking} from '@/services/iot/api_booking';
const apiBooking = new api_booking(process.env.VUE_APP_BASE_URL);

import {api_general} from '@/services/iot/api_general';
const apiGeneral = new api_general(process.env.VUE_APP_BASE_URL);

import {api_management} from '@/services/iot/api_management';
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);

import Calendar from '@/components/booking/Calendar.vue'

export default {
  name: "group_experiment_board",
  components: {
    Calendar
  },
  mixins: [],
  data: function () {
    return {
      par: "this is pars",
      componentKey: 0,
      childrenKey: 0,
      panel: [0],
      school_id: "",
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      dialog_calendar: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      form: {
        school: "",
        experiment: "",
        equipment_id: "",
        next: "",
      },
      api:{
        group_experiment_slot: [{"show": false}, {"show": false}, {"show": false}],
        schools:[],
        experiments:[{field: "BIOLOGY", experiment: "BACTERIA_GROWTH", experiment_name: "Bacteria Growth", status: "ACTIVE",create_at: "2022-09-06 15:55:17"}],
        experiments_list:[],
        book_slots: [],
        group_experiment_slots: [],
        slots: [],
        school_id: '',
        school_name: '',
        school_chi_name: '',
        school_logo_url: '',
      },
      headers_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'Experiment Set', value: 'experiment_set' },
        { text: 'From', value: 'start_at' },
        { text: 'To', value: 'end_at' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },        
      ],
      headers_slots_chi: [
        { text: '參考編號', value: 'ref' },
        { text: '實驗組', value: 'experiment_set_chi' },
        { text: '開始', value: 'start_at' },
        { text: '結束', value: 'end_at' },
        { text: '狀態', value: 'status_chi' },
        { text: '操作', value: 'actions', sortable: false },        
      ],
      headers_book_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'Experiment Set', value: 'experiment_set' },
        { text: 'Date', value: 'date' },
        { text: 'Time', value: 'time' },
        { text: 'Duration (mins)', value: 'duration' },
        { text: 'Status', value: 'status' },
        { text: 'Update At', value: 'update_at' },
        //{ text: 'Actions', value: 'actions', sortable: false },        
      ],
      headers_book_slots_chi: [
        { text: '參考編號', value: 'ref' },
        { text: '實驗組', value: 'experiment_set_chi' },
        { text: '日期', value: 'date' },
        { text: '時間', value: 'time' },
        { text: '時長(分鐘)', value: 'duration' },
        { text: '狀態', value: 'status_chi' },
        { text: '最後更新', value: 'update_at' },
        //{ text: 'Actions', value: 'actions', sortable: false },        
      ],
    };
  },
  created: function () {
    //addEventListener("beforeunload", this.beforeUnloadListener, { capture: true });
  },
  mounted: function () {
    var self = this;
    self.init();
  },
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    init(){
      var self = this;
      self.current.school_id = self.$store.state.user.school_id;
      self.current.username = self.$store.state.user.username;
      self.current.user_level = self.$store.state.user.user_level;
      self.current.auth_token = self.$store.state.user.auth_token;
      if(self.current.user_level == "USER"){
        //self.panel = "1";
      }
      if(self.current.user_level != "ADMIN" ){
        self.api.schools = [self.current.school_id];
        self.form.school_id = self.current.school_id;
        self.getUserSchool();
      }
      else {
        self.getSchoolList();
        if(self.$route.params.school_id == undefined){
          self.form.school_id = self.current.school_id;
          self.$router.push("/group_experiment_board/"+self.current.school_id);
        }
        else {
          self.form.school_id = self.$route.params.school_id;
          self.$router.push("/group_experiment_board/"+self.form.school_id);
        }
      }
  //    self.school_id = self.$route.params.school_id;    
  //    self.form.school = self.school_id;
      self.getSchoolExperiment();    
      self.getExperimentList();
      self.getOngoingGroupExperimentByUserRight();
    },
    schoolInfo({school_id, school_name, school_chi_name, school_logo_url}){
      var self = this;
      self.api.school_id = school_id;
      self.api.school_name = school_name;
      self.api.school_chi_name = school_chi_name;
      self.api.school_logo_url = school_logo_url;
    },
    getUserSchool(){
      var self = this;
      apiGeneral.getUserSchool(self.$cookies.get('username')).then((response) => {
        if(response.status=="success" && self.$route.params.school_id!=response.school){
          self.$router.push("/group_experiment_board/"+response.school+"/");
        }
      });
    },
    isBookedByMe: function (slot) {
      if ( (slot.current==true && (slot.status == "RESERVED"||slot.status == "SUSPENDED") && (slot.username == this.$cookies.get("username"))) ) {
        return true;
      }
      else {
        return false;
      }
    },    
    isOverrided(slot){
      if (slot.eStatus=="HOLD" && !slot.passed) {
        return true;
      } 
      else {
        return false;
      }
    },
    isBookedSoon: function (slot) {
      if ( slot.current==false && ( slot.status == "RESERVED" || slot.status == "SUSPENDED" || slot.status == "MAINTENANCE") && slot.username == this.$cookies.get("username") ) {
        return true;
      }
      else {
        return false;
      }
    },
    enterLab: function (slot_id, experiment, equipment_id, role, override, user_level) {
      var self = this;
      if(override == "1" && role == "player"){
        self.$store.commit("showSnackBar", "This Booking is overriding by incharge/admin, please try entering later.");        
      }
      else {
        apiBooking
          .enterLab(slot_id, self.current.username, self.current.school_id, experiment, equipment_id, self.$cookies.get("auth_token"), role, user_level)
          .then((response) => {
            if (response.status == "fail") {
              self.$store.commit("showSnackBar", response.message);
            } else {
              if(self.$i18n.locale=='tc')
                self.$store.commit("showSnackBar", "準備中...");
              else
                self.$store.commit("showSnackBar", "Preparing...");
              self.$cookies.set("session_token", response.session_token);
              self.$cookies.set("role", role);
              self.$cookies.set("school_id", self.current.school_id);
              self.$cookies.set("experiment", experiment);
              self.$cookies.set("equipment_id", equipment_id);
              self.$cookies.set("end_at", response.end_at);
              self.$cookies.set("booking_id", slot_id);
              self.$router.push(
                "/iot_experiment/" + self.current.school_id + "/" + experiment.toLowerCase() + "/" + equipment_id
              );
            }
          });
      }
    },
    getSchoolList(){
      var self = this;
      apiGeneral.getSchoolList()
      .then((response) => {
        self.api.schools = response.schools;
      });
    },
    getSchoolExperiment(){
      var self = this;
      apiManagement.getSchoolExperiment(self.form.school_id)
      .then((response) => {
          self.api.experiments = response.experiments;          
      });
    },
    getExperimentList(){
      var self = this;
      apiManagement.getExperimentList()
      .then((response) => {
          self.api.experiments_list = response.experiments;
      });
    },
    getOngoingGroupExperimentByUserRight(){
      var self = this;
      apiGeneral.getOngoingGroupExperimentByUserRight(self.form.school_id, self.current.username)
      .then((response) => {
          self.api.group_experiment_slots = response.group_experiment_slots;
      });
    },
    goTo(school_id){
      var self = this;
      self.$router.push("/group_experiment_board/"+school_id);
      self.init();      
      self.componentKey+=1;
      self.childrenKey+=1;
    },
    enterGroupLab: function (item) {
      var self = this;
      apiBooking.enterGroupLab(item.ref, self.$cookies.get("username"), self.current.school_id , item.experiment, item.equipment_id, self.$cookies.get("auth_token"), 'player', self.$cookies.get("user_level"))
        .then((response) => {
          if (response.status == "fail") {
            self.$store.commit("showSnackBar", response.message);
            self.getExperimentList();
          } else {
            if(self.$i18n.locale=='tc')
              self.$store.commit("showSnackBar", "準備中...");
            else
              self.$store.commit("showSnackBar", "Preparing...");
              self.$cookies.set("session_token", response.session_token);
              self.$cookies.set("role", 'player');
              self.$cookies.set("school_id", self.current.school_id);
              self.$cookies.set("experiment", item.experiment);
              self.$cookies.set("equipment_id", item.equipment_id);
              self.$cookies.set("end_at", response.end_at);
              self.$cookies.set("group_slot_id", item.ref);
              self.$router.push("/group_experiment/" + self.current.school_id + "/" + item.experiment.toLowerCase() + "/" + item.equipment_id);
          }
        });
    },
  },
  destroyed(){
    clearInterval(this.kick_inte);
    console.log("destroyed");
  }
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}


v-btn {
  text-transform: none;
}
</style>